import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { VOLUME_CHART_SCHEME } from '@app/shared/constants';
import { VolumeChartBucket, VolumeGrain } from '@app/shared/models/volume-dashboard.model';

@Component({
  selector: 'app-volume-trend-card',
  templateUrl: './volume-trend-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class VolumeTrendCardComponent {
  @Input({ required: true }) chart: VolumeChartBucket[] = [];
  @Input({ required: true }) grain!: VolumeGrain;

  readonly scheme = VOLUME_CHART_SCHEME;
}
